<template>
	<div class="add-user-machine-group">
		<el-dialog
			:title="$t('components.ApplicationMer.9398965-0')"
			:visible.sync="show"
			width="80%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="info"
					label-width="80px"
					:model="info">
					<!-- 编辑 -->
					<el-row :gutter="20">
						<el-col :span="12">
							<el-tag type="info">{{
								$t("components.ApplicationMer.882054-1", [unselectList.length])
							}}</el-tag>

							<el-button
								type="primary"
								class="right"
								v-if="info.id"
								size="small"
								icon="el-icon-plus"
								:disabled="unselectChangeList.length <= 0"
								@click="addMachine(0)"
								>{{ $t("addUserMachineGroup.addM") }}</el-button
							>
							<el-button
								type="primary"
								class="right"
								style="margin-right: 5px"
								v-if="info.id"
								size="small"
								:disabled="hasNull"
								@click="addAllMachine()"
								>{{ $t("components.ApplicationMer.913340-1") }}</el-button
							>
							<div
								style="
									display: flex;
									justify-content: flex-end;
									flex-wrap: wrap;
									margin-top: 10px;
								">
								<el-input
									style="width: 150px; margin-right: 10px"
									size="small"
									v-model="editUnSelect.search.machineNo"
									:placeholder="
										$t('components.ApplicationMer.882054-3')
									"></el-input>
								<el-input
									style="width: 150px; margin-right: 10px"
									size="small"
									v-model="editUnSelect.search.machineName"
									:placeholder="
										$t('components.ApplicationMer.882054-4')
									"></el-input>
								<el-input
									style="width: 150px; margin-right: 10px"
									size="small"
									v-model="editUnSelect.search.userMachineGroupName"
									:placeholder="
										$t('components.ApplicationMer.882054-5')
									"></el-input>
								<el-button
									size="small"
									type="primary"
									@click="loadEditUnSelect"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									size="small"
									@click="handlerReset(1)"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</div>
							<el-table
								v-loading="loading"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								:data="unselectList"
								height="350px"
								style="width: 100%; margin-top: 10px"
								@selection-change="unselect">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									sortable
									prop="machineNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.machineNo')
									"></el-table-column>
								<el-table-column
									sortable
									prop="name"
									:label="$t('addUserMachineGroup.machineName')"
									:show-overflow-tooltip="true"></el-table-column>
								<el-table-column
									sortable
									prop="userMachineGroupName"
									:label="$t('user.AddUserMachineGroup.619464-1')"
									:show-overflow-tooltip="true"></el-table-column>
								<el-table-column
									prop="promotionPlanName"
									:label="$t('components.ApplicationMer.9398965-1')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
						<el-col :span="12">
							<el-tag type="info">{{
								$t("components.ApplicationMer.913340-3", [selectList.length])
							}}</el-tag>
							<el-button
								type="danger"
								class="right"
								size="small"
								v-if="info.id"
								icon="el-icon-delete"
								:disabled="selectChangeList.length <= 0"
								@click="addMachine(1)"
								>{{ $t("addUserMachineGroup.remM") }}</el-button
							>
							<div
								style="
									display: flex;
									justify-content: flex-end;
									flex-wrap: wrap;
									margin-top: 10px;
								">
								<el-input
									style="width: 150px; margin-right: 10px"
									size="small"
									v-model="editSelect.search.machineNo"
									:placeholder="
										$t('components.ApplicationMer.882054-3')
									"></el-input>
								<el-input
									style="width: 150px; margin-right: 10px"
									size="small"
									v-model="editSelect.search.machineName"
									:placeholder="
										$t('components.ApplicationMer.882054-4')
									"></el-input>
								<el-input
									style="width: 150px; margin-right: 10px"
									size="small"
									v-model="editSelect.search.userMachineGroupName"
									:placeholder="
										$t('components.ApplicationMer.882054-5')
									"></el-input>
								<el-button
									size="small"
									type="primary"
									@click="loadEditSelect"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									size="small"
									@click="handlerReset(2)"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</div>
							<el-table
								v-loading="loadingSelect"
								:empty-text="$t('common.noData')"
								:element-loading-text="$t('common.loading')"
								:data="selectList"
								height="350px"
								style="width: 100%; margin-top: 10px"
								@selection-change="select">
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column
									sortable
									prop="machineNo"
									:show-overflow-tooltip="true"
									:label="
										$t('addUserMachineGroup.machineNo')
									"></el-table-column>
								<el-table-column
									sortable
									prop="name"
									:label="$t('addUserMachineGroup.machineName')"
									:show-overflow-tooltip="true"></el-table-column>
								<el-table-column
									sortable
									prop="userMachineGroupName"
									:label="$t('user.AddUserMachineGroup.619464-1')"
									:show-overflow-tooltip="true"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('info')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "ApplicationMer",
	props: {
		show: Boolean,
		info: Object,
	},
	data() {
		return {
			labelPosition: "top",
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addUserMachineGroup.pName"),
						trigger: "blur",
					},
				],
			},
			clear: false,
			loading: false,
			userMachineList: [],
			unselectList: [],
			selectList: [],
			unselectChangeList: [],
			selectChangeList: [],
			editUnSelect: {
				loading: false,
				page: {
					pageSize: -1,
					currentPage: -1,
				},
				search: {
					machineNo: null,
					machineName: null,
					userMachineGroupName: null,
				},
			},
			editSelect: {
				loading: false,
				page: {
					pageSize: -1,
					currentPage: -1,
				},
				search: {
					machineNo: null,
					machineName: null,
					userMachineGroupName: null,
				},
			},
			loadingSelect: false,
			loadingForm: false,
			hasNull: false,
		};
	},
	mounted() {
		this.clear = false;
	},
	watch: {
		unselectList: {
			handler(newVal) {
				console.log(newVal, 12);
				this.hasNull = !newVal.some(item => item.promotionPlanId === null);
			},
			deep: true,
			immediate: true, // 立即执行一次handler以初始化allIsTrueAreNull
		},
	},
	methods: {
		// 弹窗关闭事件
		closeDialog() {
			this.$emit("close");
		},
		refreshCloseDialog() {
			this.$emit("refresh");
		},
		// 弹窗打开事件
		openDialog() {
			this.unselectList = [];
			this.selectList = [];
			let userMachineRepairSet = [];
			this.info.userMachineRepair = userMachineRepairSet;
			this.loadEditSelect();
			this.loadEditUnSelect();
		},
		// 提交创建分组表单
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.SalesPlan.merSave;
					let method = this.$method.post;
					//   添加机器id
					let rData = {};
					rData.ids = this.selectList.map(item => item.id);
					rData.id = this.info.id;
					rData.type = 1;
					this.$api
						.request(url, method, rData)
						.then(res => {
							if (res.code === 0) {
								this.refreshCloseDialog();
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		// 已添加设备分组全选触发事件
		select(val) {
			this.selectChangeList = val;
		},
		// 未添加分组设备全选触发事件
		unselect(val) {
			this.unselectChangeList = val;
		},
		// 搜索重置
		handlerReset(type) {
			if (type == 1) {
				for (let key in this.editUnSelect.search) {
					this.editUnSelect.search[key] = null;
				}
				this.loadEditUnSelect();
			} else {
				for (let key in this.editSelect.search) {
					this.editSelect.search[key] = null;
				}
				this.loadEditSelect();
			}
		},
		// 滚动加载未添加分组设备
		loadEditUnSelect() {
			if (!this.editUnSelect.loading) {
				this.editUnSelect.loading = true;
				this.loading = true;

				this.$api
					.request(this.$url.SalesPlan.merList, this.$method.get, {
						promotionPlanId: this.info.id,
						searchType: "0",
						currentPage: -1,
						pageSize: -1,
						...this.editUnSelect.search,
					})
					.then(res => {
						if (res.code === 0) {
							this.unselectList = res.data.records;
						}
						this.editUnSelect.loading = false;
						this.loading = false;
					})
					.catch(() => {
						this.editUnSelect.loading = false;
						this.loading = false;
					});
			}
		},
		// 滚动加载已添加分组设备
		loadEditSelect() {
			if (!this.editSelect.loadingSelect) {
				this.editSelect.loadingSelect = true;
				this.loadingSelect = true;
				this.$api
					.request(this.$url.SalesPlan.merList, this.$method.get, {
						promotionPlanId: this.info.id,
						searchType: "1",
						currentPage: -1,
						pageSize: -1,
						...this.editSelect.search,
					})
					.then(res => {
						if (res.code === 0) {
							this.selectList = res.data.records;
						}
						this.editSelect.loadingSelect = false;
						this.loadingSelect = false;
					})
					.catch(() => {
						this.editSelect.loadingSelect = false;
						this.loadingSelect = false;
					});
			}
		},
		// 修改设备到分组
		addMachine(type) {
			//0添加 1移除
			console.log("type", type);
			console.log(this.unselectChangeList, this.selectChangeList);

			if (
				(type === 0 && this.unselectChangeList.length > 0) ||
				(type === 1 && this.selectChangeList.length > 0)
			) {
				if (type === 0) {
					this.unselectList = this.removeElements(
						this.unselectList,
						this.unselectChangeList
					);
					this.selectList = this.selectList.concat(this.unselectChangeList);
				} else {
					this.selectList = this.removeElements(
						this.selectList,
						this.selectChangeList
					);
					this.unselectList = this.unselectList.concat(this.selectChangeList);
				}
			}
		},

		/**
		 * 从大数组中剔除小数组中的元素
		 * @param {Array} largeArray - 大数组
		 * @param {Array} smallArray - 小数组
		 * @returns {Array} 剔除后的新数组
		 */
		removeElements(largeArray, smallArray) {
			const smallArrayMachineNos = smallArray.map(item => item.machineNo);

			return largeArray.filter(
				item => !smallArrayMachineNos.includes(item.machineNo)
			);
		},
		// 添加所有未分组设备
		addAllMachine() {
			let arr = [];
			this.unselectList.forEach(item => {
				if (item.promotionPlanId === null) {
					arr.push(item);
				}
			});
			this.unselectList = this.removeElements(this.unselectList, arr);
			this.selectList = this.selectList.concat(arr);
		},
		// // 移除设备分组
		// delMachine() {
		// 	if (this.selectChangeList.length > 0) {
		// 		this.info.userMachineId = this.$cloud.getIds(
		// 			this.selectChangeList
		// 		);
		// 		this.info.type = 1;
		// 		this.$api
		// 			.request(
		// 				this.$url.UserMachine.updateGroupId,
		// 				this.$method.put,
		// 				this.info
		// 			)
		// 			.then(res => {
		// 				if (res.code === 0) {
		// 					this.$notify({
		// 						title: this.$t("common.tip"),
		// 						message: res.msg,
		// 						type: "success",
		// 					});
		// 				}
		// 			})
		// 			.catch(err => {
		// 				this.$notify({
		// 					title: this.$t("common.tip"),
		// 					message: err.msg,
		// 					type: "error",
		// 				});
		// 			});
		// 	}
		// },
	},
};
</script>

<style scoped>
.right {
	float: right;
}
</style>
